// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1xyKx","alert":"SettungsInbox_alert__2_nxy"};